import { cva } from 'class-variance-authority';

/** 4×3 grid container for months. */
export const monthGridClasses =
  'tw:grid tw:grid-cols-3 tw:gap-[var(--spacing-micro)] tw:p-[var(--spacing-small)]';

/** Individual month cell button (CVA with state variants). */
export const monthCellClasses = cva(
  [
    'tw:flex tw:items-center tw:justify-center',
    'tw:py-[var(--spacing-small)] tw:px-[var(--spacing-micro)]',
    'tw:rounded-[var(--radius-8)]',
    'tw:text-12 tw:font-regular',
    'tw:transition-colors tw:duration-150',
    'tw:border-0 tw:p-0',
    'tw:cursor-pointer',
    'tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-primary tw:focus-visible:ring-inset',
  ].join(' '),
  {
    variants: {
      state: {
        default: 'tw:text-font tw:bg-white tw:hover:bg-gray-lighter',
        selected: 'tw:bg-primary tw:text-white tw:font-semibold',
        current: 'tw:text-accent tw:font-semibold tw:bg-white tw:hover:bg-gray-lighter',
        disabled: 'tw:text-gray-light tw:bg-white tw:cursor-not-allowed tw:pointer-events-none',
      },
    },
    defaultVariants: {
      state: 'default',
    },
  }
);
